var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', {
    staticClass: "membership-steps",
    attrs: {
      "justify": "center"
    }
  }, _vm._l(_vm.items, function (item, index) {
    return _c('v-col', {
      key: index,
      staticClass: "text-center",
      attrs: {
        "cols": "12",
        "md": "6",
        "lg": ""
      }
    }, [_c('div', {
      staticClass: "tit tit--sm mb-12px mb-md-16px"
    }, [_c('span', {
      staticClass: "primary--text",
      class: `text--${item.color}`
    }, [_vm._v("STEP 0" + _vm._s(index + 1))])]), _c('v-sheet', {
      attrs: {
        "color": `primary ${item.color}`,
        "height": "15"
      }
    }), _c('div', {
      staticClass: "tit tit--xs my-12px my-md-16px"
    }, [_vm._v(" " + _vm._s(item.title) + " ")]), _c('div', {
      domProps: {
        "innerHTML": _vm._s(item.text)
      }
    })], 1);
  }), 1);

}
var staticRenderFns = []

export { render, staticRenderFns }